import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import LoginForm from '../../components/LoginForm';
import config from '../../../config';
import axios from 'axios';

import './style.css';

import {
    getSessionApi,
    postSessionApi,
    sessionReset
} from '../../actions/session';

import {
    gotoHome
} from '../../actions/redirect';

class Login extends Component {
    static propTypes = {
        getSessionApi: PropTypes.func.isRequired,
        postSessionApi: PropTypes.func.isRequired,
        gotoHome: PropTypes.func.isRequired,
        session: PropTypes.object.isRequired
    };

    state = {
        big_logo: '',
        small_logo: ''
    };

    getSettingsForTenant = () => {
        let host = location.hostname;
        let splitHost = host.split('.');
        let tenant = config.defaultTenant;

        if (splitHost[0] !== 'localhost') {
            tenant = splitHost[0];
        }

        let url = `${config.apiUrl}settings/tenant/${tenant}`;

        axios.get(url).then((res) => {
            this.mapSettingsParameters(res.data.data);
        }).catch((error) => {
            console.log(error);
        });
    };

    mapSettingsParameters = (settings) => {
        for (let setting of settings) {
            if (setting.type !== 'general') {
                continue;
            }

            let data = {};
            data[setting.param] = setting.value;

            if (setting.param === 'small_logo') {
                sessionStorage.setItem('small_logo', setting.value);
            }

            this.setState(data);
        }
    };

    handleLogin = values => {
        this.props.postSessionApi(values);
    };

    handleError = (e) => {
        let src = '/images/logo.png';
        if (e.target.id === 'big-logo-preview') {
            src = '/images/medix_logo.png';
        }

        e.target.src = src;
    };

    componentWillMount() {
        document.body.style.backgroundColor = "#fff";

        this.getSettingsForTenant();
    }

    componentDidMount() {
        // Detect if user is already logged in
        if (this.props.session.get('isAuth')) {
            this.props.gotoHome();
        } else {
            this.props.sessionReset();
        }
    }

    componentWillReceiveProps(nextProps) {
        // Check login event
        if (nextProps.session !== this.props.session) {
            if (nextProps.session.get('isAuth')) {
                this.props.gotoHome();
            }
        }
    }

    render() {
        const { session } = this.props;
        let isFetching = session.get('isFetching');

        let logo = `${config.staticFiles}${this.state.big_logo}`;

        let error = session.get('error')
        let errorMessage = error && error.get('error_description')

        return (
            <div id="page-container">
                <div className="row">
                    <div className="col-md-1 col-lg-1 col-xs-1 col-sm-1">
                        &nbsp;
                    </div>
                    <div className="col-md-4 col-lg-4 col-sm-12 col-xs-12" id="login">
                        <div className="row">
                            <div id="login-logo" className="col-sm-12 col-md-12 col-xs-12">
                                <img src={logo}
                                    onError={this.handleError}
                                    id="big-logo-preview" alt="medix logo" />
                            </div>

                            <div className="col-sm-12 col-md-12 col-lg-12 col-xs-12 loginLabel">
                                <p>Please log in to access your Medix Account</p>
                            </div>

                            <div id="login-form" className="col-sm-12 col-md-12 col-xs-12">
                                <div className="row">
                                    <LoginForm
                                        onSubmit={this.handleLogin}
                                        isFetching={isFetching}
                                        errorMessage={errorMessage}
                                    />
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-12 col-lg-12 col-xs-12 loginCopyRights">
                                <p>Copyright © 2016 Medix™ All rights reserved.</p>
                            </div>

                        </div>
                    </div>
                </div>

                <div id="bg">
                    <img src="/images/login-bg.png" alt="medix background" style={{ height: '780px' }} />
                </div>

            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    session: state.session
});

export default connect(mapStateToProps, {
    getSessionApi,
    postSessionApi,
    gotoHome,
    sessionReset
})(Login);


/** WEBPACK FOOTER **
 ** ./src/containers/Login/index.js
 **/